import { SelfStudyAdminSummaryTable } from './components/SelfStudyAdminSummaryTable';
import { SelfStudyAdminNumberOfLessons } from './components/SelfStudyAdminNumberOfLessons';

interface GraphAreaProps {
  summaryTableData: any[];
  numberOfLessonsData: any[];
  summaryItem: number;
  startDateTime: Date;
  toDateTime: Date;
  endType: string[];
}

const GraphAreaStudyAdmin: React.FC<GraphAreaProps> = ({
  summaryTableData,
  numberOfLessonsData,
  summaryItem,
  startDateTime,
  toDateTime,
  endType,
}) => {
  return (
    <>
      <div className="mt-[200px] min-h-min min-w-min">
        <div className="grid grid-cols-1 gap-y-8">
          <div className="grid-item flex">
            <SelfStudyAdminNumberOfLessons
              data={numberOfLessonsData}
            ></SelfStudyAdminNumberOfLessons>
          </div>
          <div className="grid-item flex">
            <SelfStudyAdminSummaryTable
              data={summaryTableData}
              summaryItem={summaryItem}
              startDateTime={startDateTime}
              toDateTime={toDateTime}
              endType={endType}
            ></SelfStudyAdminSummaryTable>
          </div>
        </div>
      </div>
    </>
  );
};
export { GraphAreaStudyAdmin };
